import config from 'config';

import Sentry from './Sentry';

const tracesSampleRate = config.ENV === 'prod' ? 0.05 : 1;

export default new Sentry({
    sentryDSN: config.SENTRY_DSN,
    env: config.ENV,
    release: `${config.AWS_DELIVERY_STREAM_NAME}_${config.ENV}_${config.RELEASE_DATE}`,
    tracesSampleRate,
    autoSessionTracking: true,
});
